document.addEventListener('DOMContentLoaded', function () {
  const megaMenus = document.querySelectorAll('.custom-mega-details');

  if (!megaMenus.length) return;

  megaMenus.forEach((menu) => {
    const summary = menu.querySelector('summary');
    const tabButtons = menu.querySelectorAll('.custom-tab-btn');
    const panels = menu.querySelectorAll('.custom-tab-panel');

    if (!summary) return;

    // Open / Close on summary click
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = menu.hasAttribute('open');

      // Close all other mega menus first
      megaMenus.forEach((otherMenu) => {
        if (otherMenu !== menu) {
          otherMenu.removeAttribute('open');
        }
      });

      // Toggle current menu
      if (isOpen) {
        menu.removeAttribute('open');
      } else {
        menu.setAttribute('open', 'open');

        // Default first tab active when opening
        if (tabButtons.length && panels.length) {
          const activeBtn =
            menu.querySelector('.custom-tab-btn.is-active') || tabButtons[0];

          const activeTab = activeBtn.getAttribute('data-tab');

          tabButtons.forEach((btn) => btn.classList.remove('is-active'));
          panels.forEach((panel) => panel.classList.remove('is-active'));

          activeBtn.classList.add('is-active');

          const activePanel = menu.querySelector(
            `.custom-tab-panel[data-panel="${activeTab}"]`
          );
          if (activePanel) activePanel.classList.add('is-active');
        }
      }
    });

    // Tab switch on click only
    tabButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const tab = this.getAttribute('data-tab');

        tabButtons.forEach((btn) => btn.classList.remove('is-active'));
        panels.forEach((panel) => panel.classList.remove('is-active'));

        this.classList.add('is-active');

        const activePanel = menu.querySelector(
          `.custom-tab-panel[data-panel="${tab}"]`
        );
        if (activePanel) activePanel.classList.add('is-active');
      });
    });

    // Prevent click inside menu from closing it
    menu.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  // Close all mega menus on outside click
  document.addEventListener('click', function () {
    megaMenus.forEach((menu) => {
      menu.removeAttribute('open');
    });
  });

  // ESC key to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      megaMenus.forEach((menu) => {
        menu.removeAttribute('open');
      });
    }
  });
});